import {AbstractAccessGrant} from './AbstractAccessGrant';
import {TranslatedEmb} from '../../locale/message/TranslatedEmb';

export class Role extends AbstractAccessGrant {
code: string;
description: TranslatedEmb;
label: TranslatedEmb;
tags: Object;
}

